import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { showInfo, showError } from '../actions/notificationActions';

import { callApi } from '../utils';

import LoadingDots from '../components/LoadingDots';
import BuyPowerLogo from "../assets/img/buypower-logo.png";
import NewPasswordInput from '../components/NewPasswordInput/NewPasswordInput';
import { clearUserSecurityStatus } from '../actions/utilityActions';


class PasswordForm extends Component {
    state = {
      newPassword: '',
      confirmNewPassword: '',
      redirect: '',
      loading: false,
      error: ''
    };

    setInput = e => {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    };

    componentDidMount() {
      if (this.props.authenticated) {
        this.setState({ redirect: '/order/create' })
      }
    }

    submitForm = e => {
      // e.preventDefault();

      const { loading, newPassword, confirmNewPassword } = this.state;

      const token = window.location.pathname.split('/')[2];

      if (loading) return;

      if (!newPassword) {
        return this.setState({ error: 'Please enter password!' });
      }

      if (newPassword !== confirmNewPassword) {
        return this.setState({ error: 'Passwords do not match!' })
      }

      this.setState({ error: '' });

      this.setState({ loading: true });

      const payload = { password: newPassword };

      callApi(`/reset/${token}`, payload, 'post')
        .then(res => {
          this.props.dispatch(showInfo(res.message));
          // Dispatch an action to turn on "secured"
          this.props.dispatch(clearUserSecurityStatus());
          this.setState({ loading: false, redirect: '/login' });
        })
        .catch(err => {
          this.setState({ loading: false });
          this.props.dispatch(showError(err));
        })
    };

    render() {
      const { newPassword, confirmNewPassword, loading, redirect, error } = this.state;
      return redirect ? (
        <Redirect to={redirect} />
      ) : (
          <div className="reset-form">
            <div className="logo-div">
              <img src={BuyPowerLogo} width="200px" alt="Buypower logo" className="bp-logo"/>
            </div>
            
            <div className="reset-container">
              <h3 className="mb-0">Password Reset</h3>
              <div className="text-muted mt-3">Change your current password</div>
              <br />
              <label className="lmb-5">New Password</label>
              <NewPasswordInput onChange={this.setInput} value={newPassword} name='newPassword'/>
              <br />
              <label className="lmb-5">Confirm New Password</label>
              <NewPasswordInput onChange={this.setInput} value={confirmNewPassword} name='confirmNewPassword' />
              {error ? (
                      <span className="error-msg">{error}</span>
                    ) : '' }
              <button disabled={loading} className="search-btn pass mt-5" onClick={this.submitForm}>
                {loading ? 'Updating Password' : 'Change Password'}
                <LoadingDots loading={loading} />
              </button>
            </div>
            <div className="text-muted mt-5">© BuyPower Inc | All Rights Reserved</div>
          </div>
      );
    }
  }
 
  export default connect((state) => ({
    authenticated: state.auth.authenticated,
  }))(PasswordForm);



// WEBPACK FOOTER //
// ./src/views/PasswordReset.js